
<template>
<div class="form-container">
  <div class="form-region">
	   <com-page-title></com-page-title>
 <el-form :class="$store.state.operate=='详情'?'form-disabled':''" :disabled="$store.state.operate=='详情'"  ref="form" :model="form" label-width="160px">
<template v-if="form.status==100">
		 <el-form-item  required   label='标题'>
		 <el-input placeholder='请填写' v-model='form.title' maxlength='100' show-word-limit clearable></el-input>
		  </el-form-item>
		 
	<el-form-item  required   label='价格'>
	<el-input placeholder='请填写'  type="number" v-model='form.price' maxlength='100' show-word-limit clearable></el-input>
	 </el-form-item>
	 <el-form-item  required   label='原价'>
	 <el-input placeholder='请填写' type="number" v-model='form.extFlag' maxlength='100' show-word-limit clearable></el-input>
	  </el-form-item>
	  <el-form-item  required   label='天数'>
	  <el-input placeholder='请填写' type="number" v-model='form.hits' maxlength='100' show-word-limit clearable></el-input>
	   </el-form-item>
		 <el-form-item  label='是否上架'>
		<el-switch v-model='form.isShow'></el-switch>
		 </el-form-item>
		 </template>
		 <template v-if="form.status==200">
			 <el-form-item  required   label='pc标题'>
			 <el-input placeholder='请填写' v-model='form.title' maxlength='100' show-word-limit clearable></el-input>
			  </el-form-item>
			  
			  <el-form-item  required   label='h5标题'>
			  <el-input placeholder='请填写' v-model='form.subTitle' maxlength='100' show-word-limit clearable></el-input>
			   </el-form-item>
			
		 </template>
		 <template v-if="form.status==60">
		 			 <el-form-item  required   label='标题'>
		 			 <el-input placeholder='请填写' v-model='form.title' maxlength='100' show-word-limit clearable></el-input>
		 			  </el-form-item>
		 			  
		 		<el-form-item required label='摘要'>
		 		<el-input  type='textarea' v-model='form.brief' maxlength='2000' show-word-limit clearable></el-input>
		 		 </el-form-item>
		 			<el-form-item  label='内容'>
		 			<com-form-editor  v-model='form.content'></com-form-editor>
		 			 </el-form-item>
		 </template>
		<!-- <el-form-item   label='发布时间'>
		<el-date-picker type='date' placeholder='请选择' v-model='form.postTime' :editable='false'  clearable prefix-icon='none'></el-date-picker>
		 </el-form-item>
		 <el-form-item   label='开始时间'>
		<el-date-picker type='date' placeholder='请选择' v-model='form.startTime' :editable='false'  clearable prefix-icon='none'></el-date-picker>
		 </el-form-item>
		 <el-form-item   label='结束时间'>
		<el-date-picker type='date' placeholder='请选择' v-model='form.endTime' :editable='false'  clearable prefix-icon='none'></el-date-picker>
		 </el-form-item> -->
	
		 <!-- <el-form-item v-if="form.status==20"  label='维修项目'>
		 <com-form-val  placeholder='请填写' type='dict' :limit='5' v-model='form.dict' ></com-form-val>
		   </el-form-item> -->
		<!-- <el-form-item  label='键值'>
		<com-form-val  placeholder='请填写' type='dict' :limit='5' v-model='form.dict' ></com-form-val>
		 </el-form-item>
		 <el-form-item  label='参数'>
		<com-form-val  placeholder='请填写' :limit='5' v-model='form.params' ></com-form-val>
		 </el-form-item>
		 <el-form-item  label='分数'>
		<el-input placeholder='请填写' v-int  type='number' v-model='form.source' clearable></el-input>
		 </el-form-item>
		
		 <el-form-item  label='图片'>
		<com-form-uploaders  :limit='1' v-model='form.imgurl'></com-form-uploaders>
		 </el-form-item>-->
		 <!-- <el-form-item     label='楼盘'>
		 <el-input placeholder='请填写' v-model='form.dict' maxlength='100' show-word-limit clearable></el-input>
		  </el-form-item> -->
		 <!-- <el-form-item   label='发布时间'>
		  <el-date-picker type='date' placeholder='请选择' v-model='form.postTime' :editable='false'  clearable prefix-icon='none'></el-date-picker>
		   </el-form-item> -->
		 
		
		<!-- <el-form-item  label='多图'>
		<com-form-uploaders  :limit='1' v-model='form.imgurlArray'></com-form-uploaders>
		 </el-form-item>
		 <el-form-item   label='文件名称'>
		<el-input placeholder='请填写' v-model='form.fileName' maxlength='50' show-word-limit clearable></el-input>
		 </el-form-item>
		 <el-form-item   label='文件链接'>
		<el-input placeholder='请填写' v-model='form.fileUrl' maxlength='200' show-word-limit clearable></el-input>
		 </el-form-item> 
		 <el-form-item  label='内容'>
		<com-form-editor  v-model='form.content'></com-form-editor>
		 </el-form-item>-->
		<!-- <el-form-item  label='点击数'>
		<el-input placeholder='请填写' v-int  type='number' v-model='form.hits' clearable></el-input>
		 </el-form-item>
		 <el-form-item  label='真实点击数'>
		<el-input placeholder='请填写' v-int  type='number' v-model='form.hitsTrue' clearable></el-input>
		 </el-form-item>
		 <el-form-item  label='地址详情'>
		<com-form-editor  v-model='form.addressx'></com-form-editor>
		 </el-form-item>
		<com-form-map   v-model='form.address'></com-form-map>
		 <el-form-item  label='经纬度'>
		<el-input placeholder='请填写'  v-double type='number' v-model='form.longitude' clearable></el-input>
		 </el-form-item>
		 <el-form-item  label='经纬度'>
		<el-input placeholder='请填写'  v-double type='number' v-model='form.latitude' clearable></el-input>
		 </el-form-item> -->
		
   <el-form-item>
     <el-button type="primary" @click="onSubmit">立即提交</el-button>
   </el-form-item>
 </el-form>
 </div>
</div>
</template>
<script>
  export default {
	  props: {
	  	id: {//主键id
	  		type: String,
	  		default: ''
	  	}
	  },
  data() {
  return {
    dateRange:[],//表单限制日期
	
  form: {
	id:'',//ID
		mediaUrl:'',//视频链接
		mediaImage:'',//视频图片
		classId:'',//分类ID
		classIds:'',//分类IDS
		types:'',//类型ID
		groups:'',//分组ID
		status:'',//状态
		orders:'',//排序
		title:'',//标题
		subTitle:'',//副标题
		urls:'',//链接
		tag:'',//标签
		code:'',//代码
		recommend:'',//推荐
		isShow:true,//是否上架
		postTime:'',//发布时间
		startTime:'',//开始时间
		endTime:'',//结束时间
		postName:'',//发布人
		dict:'',//字典
		params:'',//参数
		price:'',//价格
		source:'',//分数
		brief:'',//摘要
		imgurl:'',//图片
		imgurls:'',//多图
		imgurlArray:'',//多图
		fileName:'',//文件名称
		tel:'',//文件链接
		fileUrl:'',//电话
		content:'',//内容
		hits:'',//点击数
		hitsTrue:'',//真实点击数
		extFlag:'',//扩展
		extMore:'',//扩展
		ext:'',//扩展字段
		createId:'',//创建ID
		createTime:'',//创建时间
		addressx:'',//地址详情
		address:'',//地址
		province:'',//省
		city:'',//市
		area:'',//区
		street:'',//街道
		longitude:'',//经纬度
		latitude:'',//经纬度
  }
  }
  },
  methods: {
 onSubmit() {//表单提交
	 this.form.id=this.$store.state.operate=='复制'?'':this.id;

	if(this.dateRange.length==2){
	  this.form.startTime=this.dateRange[0];
	  this.form.endTime=this.dateRange[1];
		 }
if(this.form.status==100){
	if(!this.form.title){this.$message.error('请填写标题');return ;}
	if(!this.form.price){this.$message.error('请填写价格');return ;}
	if(!this.form.extFlag){this.$message.error('请填写原价');return ;}
	if(!this.form.hits){this.$message.error('请填写天数');return ;}
}
if(this.form.status==60){
	if(!this.form.title){this.$message.error('请填写标题');return ;}
	if(!this.form.brief){this.$message.error('请填写摘要');return ;}
}

	 let url=this.form.id?`/api/Article/PostArticleUpdate`:`/api/Article/PostArticleAppend`;
	 let data=this.form;
 this.$axios.post(url,data).then(e => {
   this.$emit("callbackPage",{statusText:this.form.id?'编辑':'添加'}); 
  });
 }
  },mounted() {//根据id获取表单数据
    this.form.status=this.$route.query.status||'';
	  if(this.id){
		  this.$axios.get(`/api/Article/GetArticle?id=${this.id}`).then(e => {
		   this.form=e;
		    this.dateRange=this.form.startTime?[this.form.startTime,this.form.endTime]:[]
		      if(this.$store.state.operate=='复制'){
			    this.$message.success('内容已经复制到表单');
		   }
		  });
	  }
	
      }
  }
</script>
